import React from 'react';
import { DownloadGroup } from '../../types/download';
import { DownloadButton } from '../button/DownloadButton';
import SimpleTooltip from '../simple-tooltip';

interface DownloadSettingOptionProps {
  options: DownloadGroup[];
  isDisabled?: boolean;
}

export const InfoIconWithTooltip = ({ text }: { text: string }) => {
  return (
    <SimpleTooltip text={text}>
      <i className='fa fa-info-circle text-ThemeTextLight ml-2' />
    </SimpleTooltip>
  );
};

export const loadingText = <span className={'ml-2'}>Downloading</span>;

export const DownloadSettingOptions = ({ options, isDisabled }: DownloadSettingOptionProps) => {
  return (
    <>
      <h5 className='mt-3'>Download as...</h5>
      {options.map((report, i) => {
        return (
          <div key={i} className='mb-3'>
            {!report.title && !report.tooltip ? null : (
              <div className='d-flex mt-3 align-items-baseline'>
                {report.title ? <h6 className='text-ThemeTextDark'>{report.title}</h6> : null}
                {report.tooltip ? <InfoIconWithTooltip text={report.tooltip} /> : null}
              </div>
            )}
            <div className='d-flex'>
              {report.options.map((option, index) => (
                <DownloadButton
                  key={index}
                  color='link'
                  className='pl-0'
                  onClick={option.handler}
                  loadingText={loadingText}
                  disabled={isDisabled}
                >
                  <i className={`${option.icon} mr-2`} />
                  {option.type}
                </DownloadButton>
              ))}
            </div>
          </div>
        );
      })}
    </>
  );
};
